// API pour récupérer les données de la page Carrière
import { getStrapiBaseUrl, getWithLocaleFallback } from "../../services/strapiApi";

// Fonction pour récupérer les données de la page Carrière
export const getCareerPageData = async () => {
  try {
    const endpoint = '/career-page?populate[heroComponent][populate][0]=image&populate[locations]=*&populate[benefits][populate][0]=icon';
    const result = await getWithLocaleFallback(endpoint);
    return result;
  } catch (error) {
    console.error('Error fetching career page data:', error);
    return { ok: false, reason: "NETWORK_ERROR", error: error.message };
  }
};

// Fonction pour formater les données de la page Carrière
export const formatCareerPageData = (data) => {
  if (!data) return null;

  return {
    id: data.id,
    title: data.attributes?.title,
    description: data.attributes?.description,
    heroComponent: {
      title: data.attributes?.heroComponent?.data?.attributes?.title,
      description: data.attributes?.heroComponent?.data?.attributes?.description,
      image: data.attributes?.heroComponent?.data?.attributes?.image?.data?.attributes?.url
    },
    stats: data.attributes?.stats?.data?.map(stat => ({
      id: stat.id,
      value: stat.attributes?.value,
      label: stat.attributes?.label
    })) || [],
    categories: data.attributes?.categories?.data?.map(category => ({
      id: category.id,
      name: category.attributes?.name,
      color: category.attributes?.color
    })) || [],
    jobs: data.attributes?.jobs?.data?.map(job => ({
      id: job.id,
      title: job.attributes?.title,
      department: job.attributes?.department,
      location: job.attributes?.location,
      type: job.attributes?.type,
      salary: job.attributes?.salary,
      description: job.attributes?.description,
      requirements: job.attributes?.requirements,
      postedDate: job.attributes?.postedDate,
      closingDate: job.attributes?.closingDate
    })) || []
  };
};

// Fonction pour récupérer les offres d'emploi
export const getJobOffers = async () => {
  try {
    const endpoint = '/job-offers?populate[icon][fields][0]=url&populate[icon][fields][1]=name&populate[icon][fields][2]=formats&populate[requirements]=*&sort=postedDate:desc';
    const result = await getWithLocaleFallback(endpoint);
    return result;
  } catch (error) {
    console.error('Error fetching job offers:', error);
    return { ok: false, reason: "NETWORK_ERROR", error: error.message };
  }
};

// Fonction pour formater les offres d'emploi
export const formatJobOffers = (data) => {
  if (!data || !Array.isArray(data)) return [];

  return data.map(job => ({
    id: job.id,
    title: job.attributes?.title,
    department: job.attributes?.department,
    location: job.attributes?.location,
    type: job.attributes?.type,
    salary: job.attributes?.salary,
    description: job.attributes?.description,
    requirements: job.attributes?.requirements?.data?.map(req => req.attributes?.content) || [],
    postedDate: job.attributes?.postedDate,
    closingDate: job.attributes?.closingDate
  }));
};